const updatesData = [
  { date: '07-31', title: '《暗夜追光》更新至第28集', tag: '新剧上线', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-30', title: '《狂飙2026》第35集已更新上线', tag: '剧集更新', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-29', title: '播放器升级：支持4K HDR画质模式', tag: '功能升级', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-28', title: '《大奉打更人》第18集已同步更新', tag: '剧集更新', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-27', title: '暑期追剧专题上线，十大新剧排播一览', tag: '专题上线', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-26', title: 'CDN节点扩容完成，播放速度提升30%', tag: '服务升级', tagColor: 'bg-secondary-100 text-secondary-700' },
  { date: '07-25', title: '《玫瑰的故事》第22集新增弹幕功能', tag: '功能更新', tagColor: 'bg-accent-100 text-accent-700' },
  { date: '07-24', title: '悬疑剧场专区全新改版上线', tag: '专区上线', tagColor: 'bg-primary-100 text-primary-700' },
  { date: '07-23', title: 'iOS & Android 移动端版本同步更新', tag: '版本更新', tagColor: 'bg-secondary-100 text-secondary-700' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4">
            <i className="ri-timer-line"></i>
            最新动态
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">更新动态</h2>
          <p className="mt-2 text-foreground-500 text-sm">剧集更新、功能升级、平台动态一站掌握</p>
        </div>

        <div className="relative">
          <div className="absolute left-5 top-0 bottom-0 w-px bg-background-300"></div>

          <div className="space-y-5">
            {updatesData.map((item, idx) => (
              <div key={idx} className="relative flex items-start gap-5 pl-14">
                <div className={`absolute left-[14px] w-3 h-3 rounded-full border-2 ${
                  idx === 0 ? 'bg-primary-500 border-primary-500' : 'bg-background-50 border-background-300'
                }`}></div>
                <div className="flex-shrink-0 w-14 pt-0.5">
                  <span className="text-xs font-bold text-foreground-400 whitespace-nowrap">{item.date}</span>
                </div>
                <div className="flex-1 min-w-0 pb-5 border-b border-background-200">
                  <div className="flex items-start gap-2 flex-wrap">
                    <p className="text-sm text-foreground-800 font-medium">{item.title}</p>
                    <span className={`flex-shrink-0 px-1.5 py-0.5 rounded text-[10px] font-medium ${item.tagColor}`}>
                      {item.tag}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}